const MerlinActionTypes = {
  MERLIN_GENERATE_TOKEN: 'MERLIN_GENERATE_TOKEN',
  MERLIN_GENERATE_TOKEN_SUCCESS: 'MERLIN_GENERATE_TOKEN_SUCCESS',
  MERLIN_GENERATE_TOKEN_FAIL: 'MERLIN_GENERATE_TOKEN_FAIL',
  MERLIN_SET_URL: 'MERLIN_SET_URL',
  MERLIN_RESET: 'MERLIN_RESET',
  MERLIN_SET_CHAT_DATA: 'MERLIN_SET_CHAT_DATA',
};

export { MerlinActionTypes };
